import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { Icon } from '../Icon/Icon';

const LabelTooltipElement = styled.div<IProps>`
  display: flex;
  width: ${props => (props.width ? props.width + 'px' : 'auto')};
`;

const IconElement = styled.div`
  margin-top: 10px;
  margin-left: 2px;
  color: ${theme.vars.newColor.blue1};
`;

const ContentElement = styled.div`
  text-align: left;
  padding: 10px;
  padding-right: 15px;
`;

const HeadingElement = styled.div`
  font-size: 14;
  font-weight: 600;
`;

const DescriptionElement = styled.p`
  font-size: 14;
  color: ${theme.vars.newColor.darkGS2};
  margin-top: 10px;
`;

const ContentContainer = styled.div`
  margin-top: 10px;
  font-size: 14;
`;

interface IProps {
  /** Optional tooltip heading.  Defaults to undefined. */
  heading?: string;
  /** Optional tooltip description.  Defaults to undefined. */
  description?: string | string[];
  /** Optional tooltip description list. Deafults to undefined */
  content?: JSX.Element;
  /** Optional tooltip width. Defaults to auto */
  width?: string;
}

export const LabelTooltip: FC<IProps> = ({ content, description, heading, width }) => (
  <LabelTooltipElement width={width}>
    <IconElement>
      <Icon icon="info-circle" />
    </IconElement>

    <ContentElement>
      <HeadingElement>{heading}</HeadingElement>

      {description ? (
        Array.isArray(description) ? (
          description.map((descriptionText, index) => (
            <DescriptionElement key={index}>{descriptionText}</DescriptionElement>
          ))
        ) : (
          <DescriptionElement>{description}</DescriptionElement>
        )
      ) : null}

      {content && <ContentContainer>{content}</ContentContainer>}
    </ContentElement>
  </LabelTooltipElement>
);
